import { cn } from '@src/design-system/helpers';
import { Tabs, TabsList, TabsTrigger } from '@src/design-system/tabs';
import type { FC } from 'react';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import qs from 'qs';

interface TTabs {
  label: string;
  value: string;
  default?: boolean;
  icon?: React.ReactElement;
  content: React.ReactNode;
}

const FilterPills: FC<{ tabs: TTabs[] }> = ({ tabs }) => {
  const { search } = useLocation();

  const { tab: tabValueFromUrl } = qs.parse(search, {
    ignoreQueryPrefix: true,
  });

  return (
    <>
      <Tabs className='w-full'>
        <div className='flex justify-between items-center'>
          <TabsList className='border-0 h-auto gap-2 mt-3'>
            {tabs.map((tab) => {
              // const active = new Map([[tab.value === selectedTab, 'active']]);
              const queryString = qs.stringify({
                tab: tab.value,
              });

              const active = new Map([
                [
                  (!tabValueFromUrl && tab.default) ||
                    tabValueFromUrl === tab.value,
                  'active',
                ],
              ]);
              return (
                <TabsTrigger
                  key={tab.value}
                  data-state={active.get(true)}
                  value={tab.value}
                  className={cn(
                    `px-4 py-2 border font-medium text-sm capitalize transition-none data-[state=active]:bg-primary-100 cursor-pointer data-[state=active]:border data-[state=active]:border-pale-border border-pale-border text-gray-600 rounded-full`
                  )}
                >
                  <Link
                    className='flex gap-2 items-center p-0'
                    to={{ search: queryString }}
                  >
                    {tab.icon &&
                      React.cloneElement(tab.icon, {
                        variant: active.get(true) ? 'Bold' : 'Linear',
                        size: 20,
                        style: { marginRight: '8px' },
                      })}
                    {tab.label}
                  </Link>
                </TabsTrigger>
              );
            })}
          </TabsList>
        </div>
      </Tabs>

      <div className='pt-3'>
        {tabs.find(
          (tab) =>
            tabValueFromUrl === tab.value || (!tabValueFromUrl && tab.default)
        )?.content ?? null}
      </div>
    </>
  );
};

export default FilterPills;
